import * as api from '~/api';
import { DOCTOR } from '~/utils/urlApi';

export const getAllDoctorByFilter = (
  baseUrl,
  info,
  limit,
  offset,
  doctorForm,
  selectedHospital,
) => {
  const nextPage = limit * offset;
  const keys = Object.keys(doctorForm);
  const length = keys.length;
  let strQuery = '';
  for (let i = 0; i < length; i++) {
    const value = doctorForm[keys[i]].value;
    if (value !== '-1') strQuery += `&${keys[i]}=${value}`;
  }

  let router = '';
  switch (selectedHospital.id) {
    case 2:
      router = DOCTOR.GET_DOCTOR_LIST_BY_FILTER;
      break;
    case 5:
      router = DOCTOR.GET_DOCTOR_LIST_BY_FILTER_MA;
      break;
    default:
      router = DOCTOR.GET_DOCTOR_LIST_BY_FILTER;
      break;
  }
  return api.getHttpRequestAsync(
    // eslint-disable-next-line max-len
    `${baseUrl}${router}?user_id=${info.user_id}&access_token=${info.access_token}&limit=${limit}&offset=${nextPage}${strQuery}`,
  );
};
